import type { ModulePermissions } from "@/services/api/user/types";

export interface CodexAccessUser {
  role?: string;
  permissions?: string[];
}

function hasAdminGrant(
  role: string | undefined,
  permissions: string[] | undefined,
): boolean {
  const normalizedRole = (role ?? "").toLowerCase();
  if (normalizedRole === "admin" || normalizedRole === "super_admin") {
    return true;
  }
  const perms = permissions ?? [];
  return perms.includes("*") || perms.includes("admin:*");
}

/** True when the user may open Codex (admin / super-admin / wildcard permissions). */
export function canAccessCodex(
  user: CodexAccessUser | null | undefined,
  modulePermissions?: Pick<ModulePermissions, "role" | "permissions"> | null,
): boolean {
  if (hasAdminGrant(user?.role, user?.permissions)) {
    return true;
  }
  if (modulePermissions) {
    return hasAdminGrant(modulePermissions.role, modulePermissions.permissions);
  }
  return false;
}

export function canAccessCodexFromPermissions(
  permissions: Pick<ModulePermissions, "permissions" | "role"> | null | undefined,
  user: CodexAccessUser | null | undefined,
): boolean {
  return canAccessCodex(user, permissions);
}
